<template>
  <b-row>
    <b-col>
      <LoadingLine v-if="loading && !title" width="40%" height="24px" />
      <h3 v-else class="text-primary">{{ title }}</h3>
    </b-col>
  </b-row>
</template>

<script>
import LoadingLine from '@/elements/LoadingLine';

export default {
  name: 'ProgrammTitle',
  props: {
    title: {},
    loading: { default: false },
  },

  components: {
    LoadingLine,
  },
};
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/elements/ProgrammTitle.vue